import axios from "axios";
import { compress } from "../helpers/common.helper";

const apiUri = import.meta.env.GATEWAY_URI;

export default function useFAQs() {
  const getFAQ = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/faqs/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data.data;
  };
  const getFAQByCategoryAndSubCategory = async (category,subCategory) => {
    const result = await axios.get(`${apiUri}/api/v1/faqs/${category}/${subCategory}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data.data;
  };
  const queryFAQ = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (project) reqBody.project = project;
    if (sort) reqBody.sort = sort;
    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/faqs/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };
  const createFAQ = async (body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(`${apiUri}/api/v1/faqs`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result?.data?.data;
  };

  const patchFAQ = async (FAQId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.patch(
      `${apiUri}/api/v1/FAQs/${FAQId}`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data.data;
  };

  const deleteFAQ = async (FAQId) => {
    const result = await axios.delete(`${apiUri}/api/v1/faqs/${FAQId}`, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };


  return {
    queryFAQ: queryFAQ,
    getFAQ: getFAQ,
    createFAQ: createFAQ,
    patchFAQ: patchFAQ,
    deleteFAQ: deleteFAQ,
    getFAQByCategoryAndSubCategory:getFAQByCategoryAndSubCategory
  };
}
